export const ROUTERS_NAMES = {
  home: "/",
  notFound: "/not-found",
  watchDocs: "/watchdocs"
}
